import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { OauthService } from '../services/oauth.service';

@Injectable({ providedIn: 'root' })
export class LoggedGuard {
  protected router = inject(Router);
  private auth = inject(AuthService);
  private oauth = inject(OauthService);

  async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (!(await this.auth.ensureSession())) {
      return this.redirectToLogin(state);
    }

    return true;
  }

  private redirectToLogin(state: RouterStateSnapshot): boolean | UrlTree {
    const redirect = this.intendedAppUrl(state.url);

    if (redirect) {
      this.oauth.rememberPostLoginRedirect(redirect);
    }

    const query: Record<string, string> = {};
    if (this.auth.hasStoredCredentials()) {
      query.expired = '1';
    }
    if (redirect) {
      query.redirect = redirect;
    }

    if (!this.auth.hasStoredCredentials()) {
      return this.router.createUrlTree(['/auth', 'login'], { queryParams: query });
    }

    this.auth.logout(query);
    return false;
  }

  private intendedAppUrl(url: string | null): string | null {
    if (url == null || url === '' || url === '/') {
      return null;
    }

    if (url.startsWith('/auth')) {
      return null;
    }

    return url;
  }
}
